import {RaisedButton} from "material-ui";

const React = require('react');

export const FlowStepRow = (props) => {
    return (
        <tr>
            <td>{props.orderNumber}</td>
            <td>{props.email}</td>
            <td>{props.canEditPapers ? "DA" : "NU"}</td>
            <td>{props.canSetArticolBugetar ? "DA" : "NU"}</td>
            <td>{props.calling}</td>
            <td>
                {
                    <div>
                        <RaisedButton
                            primary
                            label={"Edit"}
                            onClick={() => props.onEditClicked(props.signedById, props.flowStepId, props.email, props.orderNumber, props.canEditPapers, props.calling, props.canSetArticolBugetar)}/>

                        <RaisedButton
                            secondary
                            style={{marginLeft: '10px'}}
                            label={"Delete"}
                            onClick={() => props.onDeleteClicked(props.flowStepId)}/>
                    </div>
                }
            </td>
        </tr>
    )
};